(() => {
  const currency = document.documentElement.dataset.gjCurrency;
  const template = document.documentElement.dataset.gjMoneyTemplate;
  if (!['AED', 'QAR', 'SAR'].includes(currency) || !/0[.,]00/.test(template || '')) return;
  const decimal = template.includes('0,00') ? ',' : '.';
  const thousands = decimal === ',' ? '.' : ',';
  window.formatMoney = (cents) => {
    const value = typeof cents === 'string' ? cents.replace('.', '') : cents;
    const parts = (Number(value) / 100).toFixed(2).split('.');
    const whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    const fraction = parts[1] === '00' ? '' : decimal + parts[1];
    return template.replace(/0[.,]00/, whole + fraction);
  };
})();
